import AgoraRTC, { IAgoraRTCClient, ILocalVideoTrack, ScreenVideoTrackInitConfig } from 'agora-rtc-sdk-ng';
import { environment } from 'src/enviroments';
import { getAccessToken } from '../auth/getAccessToken';

type InitVideoCallParams = {
  channelID: string;
  consultationID: string;
  userID: string;
  client: IAgoraRTCClient;
  loading: React.Dispatch<React.SetStateAction<boolean>>;
};

let screenTrack: ILocalVideoTrack | null = null;

export const screenSharingConfig: ScreenVideoTrackInitConfig = {
  encoderConfig: '720p', //480p_3
};

export const initScreenShareVideo = async ({
  channelID,
  consultationID,
  userID,
  client,
  loading,
}: InitVideoCallParams) => {
  const token = await getAccessToken(userID, consultationID, channelID);

  screenTrack = await AgoraRTC.createScreenVideoTrack(screenSharingConfig, 'disable');

  try {
    loading(true);

    await client.join(environment.AGORA.appID, channelID, token, `${Date.now()}_screen`);

    if (screenTrack) {
      await client.publish(screenTrack);
    }
  } catch (e) {
  } finally {
    loading(false);
  }

  return screenTrack;
};

export const leaveScreenShareVideo = async (client: IAgoraRTCClient) => {
  if (!screenTrack) return;

  await screenTrack.stop();
  await screenTrack.close();

  await client.leave();
  await client.stopProxyServer();
  await client.removeAllListeners();

  screenTrack = null;
};
